import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from './ui/Button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetClose } from './ui/Sheet';
export function Navbar() {
  const navLinks = [{
    name: 'HOME',
    href: '#'
  }, {
    name: 'ABOUT',
    href: '#'
  }, {
    name: 'SERVICES',
    href: '#'
  }, {
    name: 'MEMBERSHIP',
    href: '#'
  }, {
    name: 'FAQs',
    href: '#'
  }, {
    name: 'CONTACT',
    href: '#'
  }];
  return <header className="fixed top-0 w-full z-50 bg-[#1B3A5C] shadow-md h-[60px] lg:h-[80px] flex items-center font-heading" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex justify-between items-center" data-id="element-119">
        {/* Logo */}
        <div className="flex-shrink-0 flex items-center" data-id="element-120">
          <a href="#" className="flex items-center gap-2" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/3hQvX32PjH91gukK24Uyc7/busy_drones_bee_logo.png" alt="Busy Drones Cleaners Logo" className="h-14 lg:h-20 w-auto object-contain" data-id="element-122" />
            <span className="text-white font-bold text-lg hidden sm:block" data-id="element-123">
              Busy Drones Cleaners LLC
            </span>
          </a>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-124">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white text-sm font-medium hover:text-[#F5A623] transition-colors relative group" data-id="element-125">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#F5A623] transition-all group-hover:w-full" data-id="element-126"></span>
            </a>)}
          <Button className="bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold rounded-md px-6" data-id="element-127">
            Book Now
          </Button>
        </nav>

        {/* Mobile Nav Trigger */}
        <div className="lg:hidden flex items-center" data-id="element-128">
          <Sheet data-id="element-129">
            <SheetTrigger asChild data-id="element-130">
              <Button variant="ghost" size="icon" className="text-white hover:bg-white/10" aria-label="Open menu" data-id="element-131">
                <Menu className="h-6 w-6" data-id="element-132" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#1B3A5C] border-l-[#0F2440] text-white font-heading" data-id="element-133">
              <SheetHeader className="text-left mb-8" data-id="element-134">
                <SheetTitle className="text-white text-xl font-bold" data-id="element-135">
                  Menu
                </SheetTitle>
              </SheetHeader>
              <div className="flex flex-col gap-6" data-id="element-136">
                {navLinks.map(link => <SheetClose asChild key={link.name} data-id="element-137">
                    <a href={link.href} className="text-white text-lg font-medium hover:text-[#F5A623] transition-colors" data-id="element-138">
                      {link.name}
                    </a>
                  </SheetClose>)}
                <div className="mt-4" data-id="element-139">
                  <SheetClose asChild data-id="element-140">
                    <Button className="w-full bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold rounded-md py-6 text-lg" data-id="element-141">
                      Book Now
                    </Button>
                  </SheetClose>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}